import { render } from "./Main.vue?vue&type=template&id=b41d9046&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=b41d9046&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b41d9046"

export default script